import { Component, OnInit } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-public-practice-marketing',
  templateUrl: './public-practice-marketing.component.html',
  styleUrls: ['./public-practice-marketing.component.scss']
})
export class PublicPracticeMarketingComponent implements OnInit {

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0)
      }
    });
  }

  ngOnInit(): void {
  }

}
